import * as React from "react";

const WriteElasticSearch = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          d="M46.332 26.313H28.455a.818.818 0 0 1-.819-.813v-5.688c0-.446.369-.812.819-.812h23.318c.45 0 .818.366.818.813v.284c-.041 3.412-2.823 6.215-6.26 6.215z"
          fill="#F0BF1A"
        />
        <path
          d="M27.718 45v-7.313h18.696c3.436 0 6.218 2.763 6.218 6.176V45H27.718z"
          fill="#3EBEB0"
        />
        <path
          d="M46.36 35.656H27.826v-7.312H46.36A3.654 3.654 0 0 1 50.041 32c0 2.031-1.677 3.656-3.682 3.656z"
          fill="#07A5DE"
        />
        <path
          d="M39.59 28.344H27.483v7.312H39.59A14.44 14.44 0 0 0 40.04 32c0-1.34-.164-2.56-.45-3.656z"
          fillOpacity={0.42}
          fill="#231F20"
        />
        <path
          d="M34.14 20.747c-2.208 1.3-4.05 3.25-5.195 5.565H38.6c-.982-2.234-2.536-4.103-4.46-5.565z"
          fill="#D7A229"
        />
        <path
          d="M34.55 43.456a14.506 14.506 0 0 0 4.336-5.769h-9.94a13.428 13.428 0 0 0 5.604 5.77z"
          fill="#019B8F"
        />
      </g>
      <path
        fill="#7B838C"
        style={{ mixBlendMode: "color" }}
        d="M22 16h35v32H22z"
      />
      <g fill="#D2D5D8">
        <path d="M13 23.515L21.485 32 13 40.485z" />
      </g>
    </g>
  </svg>
);

export default WriteElasticSearch;

